import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './configurations.html'

/**
 * Administer Configurations route
 *
 * @namespace routes.AdminConfigurations
 * @type {TmrRoute}
 */
export const routes = [
  {
    name: 'admin.settings',
    label: 'ADMIN.SETTINGS.TITLE',
    mainMenu: 'app.admin',
    redirectTo: trans => {
      // Redirect to first child state that the user can access
      const UserStorage = trans.injector().get('UserStorage')
      let destination = 'app.error403'
      ;[
        'app.admin.settings.configurations.list',
        'app.admin.settings.appData.list',
        'app.admin.settings.operationConfigurations.list',
      ].some(state => {
        if (UserStorage.access(state)) {
          destination = state
          return true
        }
      })
      return destination
    },
    url: '/settings',
    weight: 17,
    accessControl: [
      'Resource.list',
      'Resource.Configuration.list',
      'Resource.AppData.list',
      'Resource.OperationConfiguration.list',
    ],
  },
  {
    name: 'admin.settings.configurations.list',
    label: 'ADMIN.CONFIGURATIONS.TITLE',
    url: '/system',
    component: 'tmrAdminConfigurations',
    resourceType: 'Configuration',
    resourceList: {
      searchParameters: ['code', 'value'],
    },
  },
]

/**
 * Component for {@link routes.tmrAdminConfigurations Administer Configurations route}
 *
 * @type {ngComponent}
 */
export const tmrAdminConfigurations = {
  ngType: 'component',
  templateUrl,
  bindings: resourceListBindings(),
  controller: 'tmrAdminConfigurationsController',
}

/**
 * Controller of component {@link tmrAdminConfigurations}.
 *
 * @type {ngController}
 */
export class tmrAdminConfigurationsController {
  static ngType = 'controller'

  constructor(TmrToast, Configuration) {
    'ngInject'
    Object.assign(this, { TmrToast, Configuration })
  }

  reloadConfigurations() {
    this.reloadingConfigurations = true
    this.Configuration.reload()
      .then(
        () =>
          this.TmrToast.success('ADMIN.CONFIGURATIONS.RESOURCELIST.RELOADED'),
        err => this.TmrToast.exception(err)
      )
      .finally(() => (this.reloadingConfigurations = false))
  }
}
